import { motion } from "framer-motion";

function About() {
  return (
    <>
      <div id="about-scroll" className="about-scroll"></div>

            <section className="about-section">
              <div className="container">
                  {/* Our History Card */}
                  <motion.div 
                    className="about-card"
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.8 }}
                  >
                    <div className="row align-items-center">
                      <div className="col-md-6 gap-text-right">
                        <h2 className="main-title">Our History</h2>
                        <p>
                          Established in 2017, TSS originated as a specialized provider of survey technology solutions, 
                          with a core focus on unmanned systems and positioning technology. Over the years, we have 
                          expanded our capabilities to deliver premier offshore positioning and remote operation 
                          support for the submarine cable, offshore construction, and energy sectors.
                        </p>
                      </div>
                      <div className="col-md-6">
                        <div className="about-visual">
                          <img 
                            alt="USV Operations" 
                            loading="lazy"
                            src={process.env.PUBLIC_URL + "/img/About/Our_History.png"} 
                          />
                        </div>
                      </div>
                    </div>
                  </motion.div>
      
                  {/* Current Capability Card */}
                  <motion.div 
                    className="about-card"
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.8 }}
                  >
                    <div className="row align-items-center reverse-mobile">
                      <div className="col-md-6">
                        <div className="about-visual">
                           <img 
                            alt="Current Capability" 
                            loading="lazy"
                            src={process.env.PUBLIC_URL + "/img/About/Current_Capability.png"} 
                          />
                        </div>
                      </div>
                      <div className="col-md-6 gap-text-left">
                        <h2 className="main-title">Current Capability</h2>
                        <p>
                          Today, TSS stands as a strategic partner to our clients. By combining elite survey 
                          personnel with cutting-edge technology, we ensure that every project—regardless of 
                          complexity—is executed with maximum efficiency and precision. We are committed to 
                          delivering tangible value and operational excellence in every mission we undertake.
                        </p>
                      </div>
                    </div>
                  </motion.div>
              </div>
            </section>    </>
  );
}
export default About;